import { useEffect, useMemo, useState } from 'react';
import { message } from 'antd';
import { Client } from 'types';
import API from '../../API';

interface Filters {
	search?: string | undefined;
	showRemoved?: boolean | undefined;
}

export const useClients = (filters: Filters) => {
	const [clients, setClients] = useState<Client[]>();

	useEffect(() => {
		fetchClients();
	}, []);

	const filtered = useMemo(() => {
		if (!clients) {
			return undefined;
		}

		return clients.filter((c) => {
			const search = filters.search?.trim().toLocaleLowerCase();
			if (search) {
				if (c.name.toLocaleLowerCase().includes(search)) return true;
				if (c.phone.toLocaleLowerCase().includes(search)) return true;
				if (c.nip?.toLocaleLowerCase().includes(search)) return true;
				if (c.bdo?.toLocaleLowerCase().includes(search)) return true;
				if (c.email?.toLocaleLowerCase().includes(search)) return true;

				return false;
			}

			if (filters.showRemoved === false && c.removedDate) {
				return false;
			}

			return true;
		});
	}, [filters, clients]);

	const fetchClients = async () => {
		try {
			const clients = await API.clients.getAll();

			setClients(clients);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	return filtered;
};
